const certificates = [
    
    // {
    //     link: '#',
    //     image: 'https://images.credly.com/size/680x680/images/6eeb0a98-33cb-4f72-bfc3-f89d65a3286c/image.png',
    //     name: 'Certified Information Systems Security Professional (CISSP)',
    //     issuer: 'ISC2'
    // },
    // {
    //     link: '#',
    //     image: 'https://images.credly.com/size/680x680/images/38b12225-5b48-44e1-8750-20928cc595ea/image.png',
    //     name: 'CCertified Cloud Security Professional (CCSP)',
    //     issuer: 'ISC2'
    // },
    // {
    //     link: '#',
    //     image: 'https://images.credly.com/size/680x680/images/d0891dee-6360-496c-9981-40652523b502/dbdea6794f1a6bbcc18d90eea923421aac7df6b5.png',
    //     name: 'Certified Information Security Manager® (CISM)',
    //     issuer: 'ISACA'
    // },
    // {
    //     link: '#',
    //     image: 'https://images.credly.com/size/680x680/images/5343b652-c9a0-418e-bfaf-7ed5a2ddd0c4/blob',
    //     name: 'CompTIA SecurityX ce Certification',
    //     issuer: 'CompTIA'
    // },
    {
        link: 'https://www.credly.com/badges/4d9e2300-64ba-4a00-ba1f-c97b01f0d205/public_url',
        image: 'https://images.credly.com/images/c4320f01-2ff4-4508-984a-415fc94e3aec/image.png',
        name: 'Systems Security Certified Practitioner (SSCP)',
        issuer: 'ISC2'
    },
    {
        link: 'https://www.credly.com/badges/74ed269f-4377-4ad0-84ea-6f4ebdc04576/public_url',
        image: 'https://images.credly.com/size/220x220/images/c7ac176b-15a3-4726-827a-e8cee8fe44dc/blob',
        name: 'CompTIA PenTest+ ce Certification',
        issuer: 'CompTIA'
    },
    {
        link: 'https://www.credly.com/badges/b792685a-0f08-4249-a47c-abec7a0c3df5/public_url',
        image: 'https://images.credly.com/size/220x220/images/dcd99b5b-da24-40a6-9364-62126d590c37/blob',
        name: 'CompTIA CySA+ ce Certification',
        issuer: 'CompTIA'
    },
    {
        link: 'https://www.credly.com/badges/a0da5d7d-ec6a-44c4-ac39-ec501dfcc5c8/public_url',
        image: 'https://images.credly.com/images/dbc9a5b0-1650-4b8d-a6a6-6dba09d09509/blob',
        name: 'CompTIA Project+ Certification',
        issuer: 'CompTIA'
    },
    {
        link: 'assets/downloads/ITIL4CertDanielVasquez.pdf',
        image: 'https://images.credly.com/images/8b943c4b-c186-4e9f-84aa-004322b76eed/image.png',
        name: 'ITIL® Foundation Certificate in IT Service Management',
        issuer: 'PeopleCert'
    },
    // {
    //     link: 'https://www.credly.com/badges/e993afe2-573c-4a84-9205-2f7f7ddde02d/embedded',
    //     image: 'https://images.credly.com/images/8090280a-311f-425f-a1cd-a32770b5a444/CompTIA_CSIS.png',
    //     name: 'CompTIA Secure Infrastructure Specialist – CSIS Stackable Certification',
    //     issuer: 'CompTIA'
    // },
    // {
    //     link: 'https://www.credly.com/badges/f0aede56-5466-4412-8a6b-e88705d5e9aa/embedded',
    //     image: 'https://images.credly.com/images/7f7657b9-4d1b-4b8d-b5ee-5fdf6d7ccd71/04294_CompTIA_Cert_Badges_Specialist_-_CIOS.png',
    //     name: 'CompTIA IT Operations Specialist – CIOS Stackable Certification',
    //     issuer: 'CompTIA'
    // },
    {
        link: 'https://www.credly.com/badges/f40984ed-2d5f-44c3-b07d-f7c42c6b718d/embedded',
        image: 'https://images.credly.com/images/80d8a06a-c384-42bf-ad36-db81bce5adce/blob',
        name: 'CompTIA Security+ ce Certification',
        issuer: 'CompTIA'
    },
    {
        link: 'https://www.credly.com/badges/451098bb-47a5-41ce-b0d4-860a69eb5b8e/embedded',
        image: 'https://images.credly.com/images/c70ba73e-3c8a-46fa-9d60-4a9af94ad662/blob',
        name: 'CompTIA Network+ ce Certification',
        issuer: 'CompTIA'
    },
    {
        link: 'https://www.credly.com/badges/4170553d-1cde-454e-9880-7acddff04f68/embedded',
        image: 'https://images.credly.com/size/680x680/images/f6d62c5d-1e1d-4de6-92ee-8dc8c80b1c7b/blob',
        name: 'CompTIA A+ ce Certification',
        issuer: 'CompTIA'
    },
    {
        link: 'https://www.credly.com/badges/7f4ec033-5f29-4288-9ca7-602fd61dc083/embedded',
        image: 'https://images.credly.com/images/34ed800e-c8af-4d98-b021-084ecba9a4c8/57a60c55aa1688312be5b60e7a9d2834.png',
        name: 'Full Stack Developer',
        issuer: 'UC Davis Division of Continuing and Professional Education'
    }
];
export default certificates;